module.exports = __webpack_public_path__ + "img/instagram.b07f4bf2.png";